module.exports = __webpack_public_path__ + "files/c8563ed64708938bda3768a85c91ec33.svg";